export default {
  laptopContainer: (height: number) => ({
    position: 'relative',
    width: '100%',
    height: `${height || 0}px`
  }),
  videoContainer: {
    position: 'absolute',
    top: '2.8%',
    left: '10.7%',
    right: '9.95%',
    bottom: '10.5%',
    video: {
      objectFit: 'cover'
    }
  }
};